<template>
  <div class="sv sv001">
    <div v-if="isEmergency" class="emergency">
      <div class="inner container">
        <BadgeIcon class="-md -requires"> 緊急のお知らせ</BadgeIcon>
        <div class="messages">
          <span class="message">
            <template v-if="urgentList[0].url">
              <a :href="urgentList[0].url" class="link">
                <span class="date">{{ urgentList[0].display_date }}</span>
                {{ urgentList[0].title }}
              </a>
            </template>
            <template v-else>
              <span class="date">{{ urgentList[0].display_date }}</span>
              {{ urgentList[0].title }}
            </template>
          </span>
        </div>
      </div>
    </div>

    <div class="main-img">
      <img
        src="@/assets/images/sv/sv001/main04.jpg"
        class="-spnone img-fluid"
        alt=""
      />
      <div class="-spnone container pc-main-btn">
        <BtngroupSingle class="_mb-md-30 -left">
          <BtnMain
            class="-main"
            href="/entry/agreement"
            @click="
              trackGtmEvent(
                '【click】メインビジュアル内ボタン',
                'SP,メインビジュアル下部,新規お申し込みはこちら'
              )
            "
          >
            今すぐお申し込み
          </BtnMain>
        </BtngroupSingle>
        <BtngroupSingle class="-left">
          <BtnMain class="-normal -spnone" router-name="sv021">
            いくら借りられるの？ <span class="large">３秒で診断</span>
          </BtnMain>
        </BtngroupSingle>
      </div>
      <img
        src="@/assets/images/sv/sv001/main04_sp.jpg"
        class="-pcnone img-fluid"
        alt=""
      />
<!--      <img-->
<!--        src="@/assets/images/sv/sv001/main.jpg"-->
<!--        class="-spnone img-fluid"-->
<!--        alt=""-->
<!--      />-->
<!--      <img-->
<!--        src="@/assets/images/sv/sv001/main_sp.jpg"-->
<!--        class="-pcnone img-fluid"-->
<!--        alt=""-->
<!--      />-->
<!--      <div class="main-txt">-->
<!--        <img-->
<!--          src="@/assets/images/sv/sv001/txt_img.png"-->
<!--          class="-spnone img-fluid _mb-md-30"-->
<!--          alt=""-->
<!--        />-->
<!--        <img-->
<!--          src="@/assets/images/sv/sv001/txt_img_sp01.png"-->
<!--          class="-pcnone img-fluid _mb-md-20"-->
<!--          alt=""-->
<!--        />-->
<!--        <BtngroupSingle class="-spnone">-->
<!--          <BtnMain-->
<!--            class="-main _mb-md-20"-->
<!--            router-name="en001"-->
<!--            @click="-->
<!--              trackGtmEvent(-->
<!--                '【click】メインビジュアル内ボタン',-->
<!--                'PC,メインビジュアル,新規お申し込みはこちら'-->
<!--              )-->
<!--            "-->
<!--          >-->
<!--            今すぐお申し込み-->
<!--          </BtnMain>-->
<!--        </BtngroupSingle>-->
<!--        <div class="txt-box">-->
<!--          <HeadingIcon class="-spnone">-->
<!--            <IconBox src="wakaba" class="-sm"></IconBox>-->
<!--            <a href="#section_01" class="-link"-->
<!--              ><span-->
<!--                @click="-->
<!--                  trackGtmEvent(-->
<!--                    '【click】メインビジュアル内ボタン',-->
<!--                    'PC,メインビジュアル,ローンをはじめて利用される方はこちら'-->
<!--                  )-->
<!--                "-->
<!--                >ローンをはじめて利用される方はこちら</span-->
<!--              ></a-->
<!--            >-->
<!--          </HeadingIcon>-->
<!--        </div>-->
<!--        &lt;!&ndash;<p class="txt01 -spnone">ローンをはじめて利用される方はこちら</p>&ndash;&gt;-->
<!--      </div>-->
    </div>

    <template v-if="isWebView()">
      <div class="-pcnone container sp-main-btn">
        <BtngroupSingle class="_mb-sm-15">
          <BtnMain
            class="-main"
            href="/entry/agreement"
            @click="
              trackGtmEvent(
                '【click】メインビジュアル内ボタン',
                'SP,メインビジュアル下部,新規お申し込みはこちら'
              )
            "
          >
            今すぐお申し込み
          </BtnMain>
        </BtngroupSingle>
        <BtngroupSingle class="_mb-sm-20">
          <BtnMain class="-normal -pcnone" router-name="sv021">
            いくら借りられるの？ <span class="large">３秒で診断</span>
          </BtnMain>
        </BtngroupSingle>
      </div>
    </template>
    <template v-else>
      <div class="-pcnone container sp-main-btn">
        <BtngroupSingle class="_mb-sm-15">
          <BtnMain
            class="-main"
            router-name="en001"
            @click="
              trackGtmEvent(
                '【click】メインビジュアル内ボタン',
                'SP,メインビジュアル下部,新規お申し込みはこちら'
              )
            "
          >
            今すぐお申し込み
          </BtnMain>
        </BtngroupSingle>
        <BtngroupSingle class="_mb-sm-20">
          <BtnMain class="-normal -pcnone" router-name="sv021">
            いくら借りられるの？<span class="large">３秒で診断</span>
          </BtnMain>
        </BtngroupSingle>
      </div>
    </template>

    <div class="container _pl-sm-0 _pr-sm-0 _mb-sm-20">
      <div class="btn-box flex _mb-md-60">
        <div class="btn-point _pr-sm-10 _mb-sm-20 _mr-md-20">
          <router-link
            :to="{ name: 'sv002', hash: '#section_01' }"
            @click="trackGtmEvent('【click】ポイント', 'ポイント①')"
          >
            <img
              src="@/assets/images/sv/sv001/btn_01.jpg"
              class="-spnone img-fluid"
              alt=""
            />
            <img
              src="@/assets/images/sv/sv001/btn_sp01.jpg"
              class="-pcnone img-fluid"
              alt=""
            />
          </router-link>
        </div>
        <div class="btn-point _pl-sm-10 _mb-sm-20 _mx-md-20">
          <router-link
            :to="{ name: 'sv002', hash: '#section_02' }"
            @click="trackGtmEvent('【click】ポイント', 'ポイント②')"
          >
            <img
              src="@/assets/images/sv/sv001/btn_02.jpg"
              class="-spnone img-fluid"
              alt=""
            />
            <img
              src="@/assets/images/sv/sv001/btn_sp02.jpg"
              class="-pcnone img-fluid"
              alt=""
            />
          </router-link>
        </div>
        <div class="btn-point _pr-sm-10 _mx-md-20">
          <router-link
            :to="{ name: 'sv002', hash: '#section_03' }"
            @click="trackGtmEvent('【click】ポイント', 'ポイント③')"
          >
            <img
              src="@/assets/images/sv/sv001/btn_03.jpg"
              class="-spnone img-fluid"
              alt=""
            />
            <img
              src="@/assets/images/sv/sv001/btn_sp03.jpg"
              class="-pcnone img-fluid"
              alt=""
            />
          </router-link>
        </div>
        <div class="btn-point _pl-sm-10 _ml-md-20">
          <router-link
            :to="{ name: 'sv002', hash: '#section_04' }"
            @click="trackGtmEvent('【click】ポイント', 'ポイント④')"
          >
            <img
              src="@/assets/images/sv/sv001/btn_04.jpg"
              class="-spnone img-fluid"
              alt=""
            />
            <img
              src="@/assets/images/sv/sv001/btn_sp04.jpg"
              class="-pcnone img-fluid"
              alt=""
            />
          </router-link>
        </div>
      </div>
    </div>

    <section>
      <div v-if="campaignBannerList.length > 0" class="container swiper-box">
        <SwiperBanner
          :banner-list="campaignBannerList.slice(0, 3)"
          :event-list="campaignEventList"
        />
        <p class="-textcenter -pctextright _mb-sm-20 _mb-md-30">
          <BtnText router-name="cp001" class="-next"
            >キャンペーン一覧へ</BtnText
          >
        </p>
      </div>
    </section>

    <section>
      <div class="bg-box01">
        <div class="container _pl-sm-0 _pr-sm-0">
          <div class="btn-bg flex">
            <BtnMain
              class="_mb-sm-10 -normal _ml-sm-15 _mr-sm-15"
              router-name="sv021"
              @click="
                trackGtmEvent(
                  '【click】中段ボタン',
                  '中段ボタン,いくら借りられるの？チェック'
                )
              "
            >
              <span class="txt01">お借り入れ可能かすぐに診断</span
              ><br />いくら借りられるの？チェック
            </BtnMain>
            <BtnMain
              class="_mb-sm-20 -normal _ml-sm-15 _mr-sm-15"
              router-name="sv052"
              @click="
                trackGtmEvent(
                  '【click】中段ボタン',
                  '中段ボタン,ご返済シュミレーション'
                )
              "
            >
              <span class="txt01">計画的なご返済プランを</span
              ><br />ご返済シミュレーション
            </BtnMain>
            <div class="right-box">
              <div class="left">
                <router-link
                  :to="{ name: 'ce001' }"
                  class="-underline"
                  @click="
                    trackGtmEvent(
                      '【click】中段ボタン',
                      '中段ボタン,会員さまログイン'
                    )
                  "
                >
                  <div class="btn-01">
                    <IconBox
                      src="login"
                      class="-md _mr-sm-10 _mb-md-10"
                    ></IconBox>
                    <span class="txt02"
                      >会員さま<br class="-spnone" />ログイン</span
                    >
                  </div>
                </router-link>
              </div>
              <div class="right _ml-md-60">
                <router-link
                  :to="{ name: 'ce001' }"
                  class="-underline"
                  @click="
                    trackGtmEvent(
                      '【click】中段ボタン',
                      '中段ボタン,お申し込み後の審査結果確認'
                    )
                  "
                >
                  <div class="btn-02">
                    <IconBox
                      src="note"
                      class="-md _mr-sm-10 _mb-md-10"
                    ></IconBox>
                    <span class="txt02">お申し込み後の<br />審査結果確認</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <HeadingTwo class="_mt-md-120">ご利用方法のご案内</HeadingTwo>
        <div class="how-to flex">
          <div class="card">
            <div class="card-body">
              <p class="card-title">
                <IconBox src="pen" class="-md -db"></IconBox>
                新規お申し込みについて
              </p>
              <ListGroup variant="-link">
                <ListItem
                  variant="-link"
                  router-name="sv045"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,お申し込み条件・お手続きの流れ'
                    )
                  "
                  >お申し込み条件・お手続きの流れ</ListItem
                >
                <ListItem
                  variant="-link"
                  router-name="sv019"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,お申し込みに必要な書類'
                    )
                  "
                  >お申し込みに必要な書類</ListItem
                >
              </ListGroup>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <p class="card-title">
                <IconBox src="loan" class="-md -db"></IconBox>
                お借り入れについて
              </p>
              <ListGroup variant="-link">
                <ListItem
                  variant="-link"
                  router-name="sv024"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,au PAY プリペイドカードにチャージ'
                    )
                  "
                  >au PAY 残高にチャージ</ListItem
                >
                <ListItem
                  variant="-link"
                  router-name="sv023"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,ご登録口座へのお振込み'
                    )
                  "
                  >ご登録口座へのお振込み</ListItem
                >
                <ListItem
                  variant="-link"
                  router-name="sv025"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,セブン銀行スマホATM'
                    )
                  "
                  >セブン銀行スマホATM</ListItem
                >
              </ListGroup>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <p class="card-title">
                <IconBox src="return" class="-md -db"></IconBox>
                ご返済について
              </p>
              <ListGroup class="-link _mb-sm-0">
                <ListItem
                  class="-link"
                  router-name="sv026"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,ご登録口座からのお引落し'
                    )
                  "
                  >ご登録口座からのお引落し</ListItem
                >
                <ListItem
                  class="-link"
                  router-name="sv029"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,セブン銀行スマホATM'
                    )
                  "
                  >セブン銀行スマホATM</ListItem
                >
                <ListItem
                  class="-link"
                  router-name="sv027"
                  @click="
                    trackGtmEvent(
                      '【click】ご利用方法のご案内',
                      'ご利用方法のご案内,指定口座へのお振込み'
                    )
                  "
                  >指定口座へのお振込み</ListItem
                >
              </ListGroup>
            </div>
          </div>
        </div>
        <template v-if="isWebView()">
          <BtngroupSingle class="-margin-lg">
            <BtnMain
              class="-main"
              href="/entry/agreement"
              @click="
                trackGtmEvent(
                  '【click】ご利用方法のご案内',
                  'ご利用方法のご案内,新規お申し込みはこちら'
                )
              "
            >
              新規お申し込みはこちら
            </BtnMain>
          </BtngroupSingle>
        </template>
        <template v-else>
          <BtngroupSingle class="-margin-lg">
            <BtnMain
              class="-main"
              router-name="en001"
              @click="
                trackGtmEvent(
                  '【click】ご利用方法のご案内',
                  'ご利用方法のご案内,新規お申し込みはこちら'
                )
              "
            >
              新規お申し込みはこちら
            </BtnMain>
          </BtngroupSingle>
        </template>
      </div>
    </section>

    <section id="section_01">
      <div class="bg-box02">
        <div class="container">
          <HeadingTwo class="_mt-0 _mb-md-30"
            >ローンについての疑問を解決！<br />知っておきたい！ローンについて</HeadingTwo
          >
          <p class="-textcenter _mb-md-60">
            au PAY
            スマートローンの特徴や、ローンについて不安に思うことなど分かりやすく解説します。
          </p>
          <CardGroups class="-image-top-list _mb-md-20 _mb-sm-40">
            <div class="card-box -image-top _mb-sm-10">
              <router-link
                :to="{ name: 'sv002' }"
                class="-anchor"
                @click="
                  trackGtmEvent(
                    '【click】知ってトクする',
                    '知ってトクするau PAY スマートローン,au PAY スマートローンの特徴'
                  )
                "
              >
                <CardHeader>
                  <CardImage class="-orange"
                    ><img
                      src="@/assets/images/sv/sv001/img01.jpg"
                      class="img-fluid"
                      alt=""
                  /></CardImage>
                  <h3 class="heading">au PAY スマートローンとは？</h3>
                </CardHeader>
                <CardBody
                  >お申し込みからご利用まで、スマートフォンがあればかんたんにスマートに！</CardBody
                >
                <ListGroup variant="-link">
                  <ListItem variant="-link"
                    >au PAY スマートローンの特徴&nbsp;&nbsp;<img
                      src="@/assets/images/icons/arrow-right-gray.svg"
                      class=""
                      alt=""
                  /></ListItem>
                </ListGroup>
              </router-link>
            </div>
            <div class="card-box -image-top _mb-sm-10">
              <router-link
                :to="{ name: 'sv043' }"
                class="-anchor"
                @click="
                  trackGtmEvent(
                    '【click】知ってトクする',
                    '知ってトクするau PAY スマートローン,いまさら聞けない！ローンの基礎知識'
                  )
                "
              >
                <CardHeader>
                  <CardImage class="-green"
                    ><img
                      src="@/assets/images/sv/sv001/img02.jpg"
                      class="img-fluid"
                      alt=""
                  /></CardImage>
                  <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
                </CardHeader>
                <CardBody
                  >「金利・利息・実質年率ってなんだろう？」…いまさら聞けないローンのキホンについて！</CardBody
                >
                <ListGroup variant="-link">
                  <ListItem variant="-link"
                    >いまさら聞けない！ローンの基礎知識&nbsp;&nbsp;<img
                      src="@/assets/images/icons/arrow-right-gray.svg"
                      class=""
                      alt=""
                  /></ListItem>
                </ListGroup>
              </router-link>
            </div>
            <div class="card-box -image-top _mb-sm-10">
              <router-link
                :to="{ name: 'sv042' }"
                class="-anchor"
                @click="
                  trackGtmEvent(
                    '【click】知ってトクする',
                    '知ってトクするau PAY スマートローン,教えて！みんなのローン活用術'
                  )
                "
              >
                <CardHeader>
                  <CardImage class="-blue"
                    ><img
                      src="@/assets/images/sv/sv001/img03.jpg"
                      class="img-fluid"
                      alt=""
                  /></CardImage>
                  <h3 class="heading">
                    ”ちょっとだけ”がすごく助かる生活の工夫
                  </h3>
                </CardHeader>
                <CardBody
                  >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
                >
                <ListGroup variant="-link">
                  <ListItem variant="-link"
                    >教えて！みんなのローン活用術&nbsp;&nbsp;<img
                      src="@/assets/images/icons/arrow-right-gray.svg"
                      class=""
                      alt=""
                  /></ListItem>
                </ListGroup>
              </router-link>
            </div>
          </CardGroups>
          <BtngroupSingle>
            <BtnMain
              class="-normal -lg"
              router-name="sv003"
              @click="
                trackGtmEvent(
                  '【click】知ってトクする',
                  '知ってトクするau PAY スマートローン,知ってトクする！ローン'
                )
              "
            >
              知っておきたい！ローンについて
            </BtnMain>
          </BtngroupSingle>
        </div>
      </div>
    </section>

    <section class="-border">
      <div class="container">
        <HeadingTwo class="_mt-md-120"
          >au PAY 残高にチャージすればスマートにおトクに使えます！</HeadingTwo
        >
        <div class="border-box">
          <div class="img-box">
            <img
              src="@/assets/images/sv/sv001/img04.png"
              class="img-fluid"
              alt=""
            />
          </div>
          <div class="txt-box">
            <p class="ttl _mb-md-20">
              au PAY 残高にチャージができて、すぐに使える！
            </p>
            <p>
              au PAY プリペイドカードやau
              PAYで毎日のお買い物に使えて、Pontaポイントもたまるのでおトクで便利！
            </p>
            <BtnText
              router-name="sv002"
              class="-next"
              @click="
                trackGtmEvent(
                  '【click】プリペ説明',
                  'プリペ説明,au PAY スマートローンの特徴'
                )
              "
              >au PAY スマートローンの特徴へ</BtnText
            >
          </div>
        </div>
        <div class="au-wallet">
          <div class="card _mb-sm-40">
            <div class="img-box">
              <img
                src="@/assets/images/sv/sv001/img05.gif"
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="card-body">
              <h4 class="card-title">
                au PAY 残高に<br />かんたんにチャージができる
              </h4>
              <p class="card-text">
                スマートフォンがあればどこにいても借り入れが可能です！<br />通勤途中やお昼休みなどのちょっとした時間でお手続きが完了します。
              </p>
            </div>
          </div>
          <div class="card _mb-sm-40">
            <div class="img-box">
              <img
                src="@/assets/images/sv/sv001/img06.gif"
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="card-body">
              <h4 class="card-title">
                チャージした残高はau PAY <br />プリペイドカードやau PAYで使える
              </h4>
              <p class="card-text">
                全国のコンビニ・スーパーやMastercard®加盟店、<br />au
                PAY加盟店などいろいろな場所で使えます。
              </p>
            </div>
          </div>
          <div class="card">
            <div class="img-box">
              <img
                src="@/assets/images/sv/sv001/img07.gif"
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="card-body">
              <h4 class="card-title">
                au PAY プリペイドカードや<br />au
                PAYで使えばPontaポイントがたまる
              </h4>
              <p class="card-text">
                ご利用額200円（税込）ごとに1Pontaポイント、<br />Pontaポイントがたまります。
              </p>
            </div>
          </div>
        </div>
        <template v-if="isWebView()">
          <BtngroupSingle class="-margin-lg">
            <BtnMain
              class="-main"
              href="/entry/agreement"
              @click="
                trackGtmEvent(
                  '【click】知ってトクする',
                  'プリペ説明,新規お申し込みはこちら'
                )
              "
            >
              新規お申し込みはこちら
            </BtnMain>
          </BtngroupSingle>
        </template>
        <template v-else>
          <BtngroupSingle class="-margin-lg">
            <BtnMain
              class="-main"
              router-name="en001"
              @click="
                trackGtmEvent(
                  '【click】知ってトクする',
                  'プリペ説明,新規お申し込みはこちら'
                )
              "
            >
              新規お申し込みはこちら
            </BtnMain>
          </BtngroupSingle>
        </template>
      </div>
    </section>
    <section>
      <div class="news container _mb-md-80 _mb-sm-40">
        <HeadingTwo class="_mt-md-120 _mt-sm-60">お知らせ</HeadingTwo>
        <TabBordered :active="selectedTab">
          <TabHeader class="-md">
            <TabItem tab-name="tab01" @onclick="setTab">重要なお知らせ</TabItem>
            <TabItem tab-name="tab02" @onclick="setTab">トピックス</TabItem>
            <TabItem tab-name="tab03" @onclick="setTab"
              >ニュースリリース</TabItem
            >
          </TabHeader>
          <TabBody tab-name="tab01">
            <template v-if="noticeList.length > 0">
              <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
                <ListItem
                  v-for="(item, index) of noticeList.slice(0, 3)"
                  :key="'topics' + index"
                  class="-link"
                  :href="item.url"
                >
                  <span class="date">{{ item.display_date }}</span
                  >{{ item.title }}
                </ListItem>
              </ListGroup>
            </template>
            <template v-else>
              <p>「重要なお知らせ」は、現在ございません。</p>
            </template>
            <BtngroupSingle>
              <BtnMain class="-normal" router-name="nw003">
                重要なお知らせ一覧
              </BtnMain>
            </BtngroupSingle>
          </TabBody>
          <TabBody tab-name="tab02">
            <template v-if="topicList.length > 0">
              <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
                <ListItem
                  v-for="(item, index) of topicList.slice(0, 3)"
                  :key="'topics' + index"
                  class="-link"
                  :href="item.url"
                >
                  <span class="date">{{ item.display_date }}</span
                  >{{ item.title }}
                </ListItem>
              </ListGroup>
            </template>
            <template v-else>
              <p>「TOPICS」は、現在ございません。</p>
            </template>
            <BtngroupSingle>
              <BtnMain class="-normal" router-name="nw001">
                トピックス一覧
              </BtnMain>
            </BtngroupSingle>
          </TabBody>
          <TabBody tab-name="tab03">
            <template v-if="newsList.length > 0">
              <ListGroup class="-link -visited _mb-md-60 _mb-sm-30">
                <ListItem
                  v-for="(item, index) of newsList.slice(0, 3)"
                  :key="'news' + index"
                  class="-link"
                  :href="item.url"
                >
                  <span class="date">{{ item.display_date }}</span
                  >{{ item.title }}
                </ListItem>
              </ListGroup>
            </template>
            <template v-else>
              <p>「ニュースリリース」は、現在ございません。</p>
            </template>
            <BtngroupSingle>
              <BtnMain class="-normal" router-name="nw005">
                ニュースリリース一覧
              </BtnMain>
            </BtngroupSingle>
          </TabBody>
        </TabBordered>
      </div>
    </section>
  </div>
</template>

<script>
import {
  getUrgentList,
  getNoticeList,
  getTopicsList,
  getNewsList,
  getCampaignBannerList,
} from "@/utils/CmsHelper";
import { trackGtmEvent } from "@/utils/Gtm";
import { setMeta } from "@/utils/Meta";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import IconBox from "@/components/icons/IconBox";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardGroups from "@/components/card/CardGroups";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
import BtnText from "@/components/button/BtnText";
import TabBordered from "@/components/tabs/TabBordered";
import TabHeader from "@/components/tabs/TabHeader";
import TabItem from "@/components/tabs/TabItem";
import TabBody from "@/components/tabs/TabBody";
// import HeadingIcon from "@/components/heading/HeadingIcon";
import BadgeIcon from "@/components/badges/BadgeIcon";
import SwiperBanner from "@/components/swiper/SwiperBanner";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv001",
  components: {
    BadgeIcon,
    // HeadingIcon,
    TabBody,
    TabItem,
    TabHeader,
    TabBordered,
    BtnText,
    CardBody,
    CardImage,
    CardHeader,
    CardGroups,
    ListItem,
    ListGroup,
    HeadingTwo,
    IconBox,
    BtnMain,
    BtngroupSingle,
    SwiperBanner,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン",
      titleTemplate: null,
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });

    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      noticeList: [],
      topicList: [],
      newsList: [],
      campaignBannerList: [],
      campaignEventList: [
        { category: "【click】広告バナー", action: "広告バナー１枠目" },
        { category: "【click】広告バナー", action: "広告バナー２枠目" },
        { category: "【click】広告バナー", action: "広告バナー３枠目" },
      ],
      isEmergency: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
          },
        },
      },
      selectedTab: "tab01",
    };
  },
  mounted() {
    getUrgentList()
      .then((res) => {
        this.urgentList = res.urgent || [];
        this.isEmergency = this.urgentList.length > 0;
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error) => {
        // eslint-disable-line
        // this.goToErrorPage(error)
      });
    getNoticeList()
      .then((res) => {
        this.noticeList = res.notice || [];
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error) => {
        // eslint-disable-line
        // this.goToErrorPage(error)
      });
    getTopicsList()
      .then((res) => {
        this.topicList = res.topics || [];
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error) => {
        // eslint-disable-line
        // this.goToErrorPage(error)
      });
    getNewsList()
      .then((res) => {
        this.newsList = res.news || [];
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error) => {
        // eslint-disable-line
        // this.goToErrorPage(error)
      });
    getCampaignBannerList()
      .then((res) => {
        this.campaignBannerList = res.campaign_banner || [];
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error) => {
        // eslint-disable-line
        // this.goToErrorPage(error)
      });
  },
  methods: {
    setTab(tabName) {
      this.selectedTab = tabName;
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.sv001 {
  > .emergency {
    background-color: $red;
    margin-top: -20px;
    margin-bottom: 20px;
    > .inner {
      margin: 0 auto;
      color: $danger;
      padding: 20px;
      font-size: 14px;
      @include mq-up(md) {
        @include flex(flex, flex-start, center, row, nowrap);
        padding: 20px 0;
        font-size: 16px;
      }
      > .messages {
        display: block;
        > .message {
          margin-top: 10px;
          &:first-child {
            margin-top: 0px;
          }
          > .link {
            color: $white;
            text-decoration: underline;
          }
          .date {
            display: block;
            font-size: 12px;
            @include mq-up(md) {
              font-size: 14px;
            }
          }
        }
      }
      > .badge-icon {
        font-size: 12px;
        margin-bottom: 10px;
        background-color: $white;
        color: $red;
        @include mq-up(md) {
          font-size: 14px;
          margin: 0 20px;
        }
        > .icon {
          width: 14px;
        }
      }
    }
  }
  .-underline {
    &:hover {
      .txt02 {
        text-decoration: underline !important;
      }
    }
  }
  .btn-box {
    @include mq-down(md) {
      border-top: 1px solid $secondary;
      border-bottom: 1px solid $secondary;
      padding: 20px 15px;
    }
    @include mq-up(md) {
      background-color: #fff;
      padding-top: 60px;
      margin-top: -15px;
      position: relative;
      border-radius: 10px 10px 0 0;
    }
    &.flex {
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      .btn-point {
        @include mq-up(md) {
          max-width: 270px;
          width: 100%;
        }
        @include mq-down(md) {
          width: 50%;
        }
      }
    }
  }
  .main-img {
    position: relative;
    margin-bottom: 15px;
    margin-top: -20px !important;
    @include mq-up(md) {
      max-width: 1600px;
      width: 100%;
      margin: 0 auto;
    }
    .main-txt {
      max-width: 70%;
      width: 100%;
      color: $white;
      width: 100%;
      position: absolute;
      color: #fff;
      text-align: center;
      @include mq-down(md) {
        top: 6%;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
      @include mq-up(md) {
        max-width: 33%;
        top: 10%;
        right: 12%;
      }
      .txt-box {
        @include mq-down(md) {
          text-align: right;
          margin-right: 22px;
        }
        .btn-text {
          color: $white;
          &.-next {
            background-image: url("@/assets/images/icons/arrow-right-white.svg");
          }
        }
        > .heading-icon {
          > a.-link {
            font-size: 18px;
            color: $white;
          }
        }
      }
      .btn-main {
        padding-top: 30px;
        padding-bottom: 30px;
        border-radius: 60px;
        font-size: 30px;
        background-size: 13px;
        width: 410px;
      }
    }
    .pc-main-btn {
      position: absolute;
      bottom: 10%;
      text-align: center;
      .-left {
        display: flex;
        margin-left: 28px;
      }
      .btn-main {
        width: 30vw;
        min-width: 380px;
        max-width: 470px;
      }
      .btn-main.-main {
        padding: 24px 40px;
        font-size: 28px;
        border-radius: 40px;
        background-color: #42949D;
        border: none;
        font-weight: bold;
      }
      .btn-main.-normal {
        padding: 24px 40px;
        border-radius: 40px;
        background-image: url("@/assets/images/icons/arrow-right-gray.svg");
        border-color: $orange;
        font-size: 16px;
        font-weight: bold;
        > .large {
          font-size: 20px;
          color: $primary;
        }
      }
    }
  }
  .sp-main-btn {
    text-align: center;
    .txt-img {
      width: 280px;
      margin-bottom: 10px;
    }
    .btn-main.-main {
      padding: 24px 40px;
      font-size: 20px;
      border-radius: 40px;
      background-color: #42949D;
      border: none;
    }
    .btn-main.-normal {
      background-image: url("@/assets/images/icons/arrow-right-gray.svg");
      border-color: $orange;
      @include mq-down(xs) {
        border-radius: 40px;
      }
      > .large {
        font-size: 17px;
        @include mq-down(xs) {
          display: block;
          padding-top: 2px;
        }
      }
    }
  }
  .bg-box01 {
    background-color: $light;
    padding-top: 15px;
    @include mq-up(md) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
  .how-to {
    @include mq-up(md) {
      margin-bottom: 60px;
    }
    &.flex {
      align-items: flex-start;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
    }
    .card {
      width: 100%;
      @include mq-up(md) {
        max-width: 340px;
      }
      .card-body {
        > .card-title {
          font-size: 18px;
          line-height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0;
          padding-bottom: 20px;
          border-bottom: 2px solid $primary;
          @include mq-up(md) {
            font-size: 24px;
          }
          img {
            width: 35px;
            margin-right: 10px;
            @include mq-up(md) {
              width: 40px;
            }
          }
        }
        > .list-group {
          @include mq-down(md) {
            margin-bottom: 40px;
          }
          .list-item {
            &.-link:first-child {
              border-top: $secondary dotted 0px;
            }
            .atag {
              &:hover {
                color: $black;
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
  .bg-box02 {
    background-color: $success;
    padding-top: 60px;
    padding-bottom: 60px;
    @include mq-up(md) {
      padding-top: 120px;
      padding-bottom: 120px;
    }
    .card-groups {
      &.-image-top-list {
        align-items: stretch;
        .card-box {
          background: $white;
          border-radius: 10px;
          @include mq-up(md) {
            width: 31.5% !important;
          }
          a.-anchor {
            display: flex;
            flex-direction: column;
            height: 100%;
            &:hover {
              text-decoration: underline;
            }
          }
          .card-image {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            img {
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
              @include mq-up(md) {
                max-height: 189px;
              }
            }
          }
          .heading {
            padding-left: 20px !important;
            padding-right: 20px !important;
          }
          .card-body {
            padding-left: 20px !important;
            padding-right: 20px !important;
            padding-bottom: 20px;
          }
          .list-group {
            margin-bottom: 0;
            @include mq-up(md) {
              margin-top: auto;
            }
            > .list-item {
              text-align: center;
              font-size: 16px;
              line-height: 24px;
              padding: 25px 25px 25px 0px;
              &.-link {
                border-bottom: 0;
                background-image: none;
                > .atag {
                  text-align: center;
                  padding-left: 0;
                  padding-right: 0;
                }
                img {
                  width: 8px;
                }
              }
              &.-link:first-child {
                border-top: $secondary solid 1px;
              }
            }
          }
        }
      }
    }
  }
  .-border {
    border-bottom: 1px solid $secondary;
  }
  .border-box {
    border: 1px solid $primary;
    border-radius: 10px;
    margin-bottom: 60px;
    @include mq-up(md) {
      display: flex;
    }
    @include mq-down(md) {
      padding: 0 20px 20px 20px;
    }
    .img-box {
      margin-top: -20px;
      @include mq-up(md) {
        margin-left: 4%;
        width: 33%;
      }
    }
    .txt-box {
      @include mq-up(md) {
        width: 56%;
        margin-left: 7%;
        padding-right: 20px;
      }
      > .ttl {
        font-size: 18px;
        line-height: 24px;
        color: $primary;
        font-weight: bold;
        padding-top: 30px;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 32px;
          padding-top: 44px;
          padding-right: 30px;
        }
      }
      > .-underline {
        &:hover {
          text-decoration: underline;
        }
        img {
          width: 8px;
        }
      }
    }
  }
  .au-wallet {
    text-align: center;
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }
    > .card {
      @include mq-up(md) {
        width: 33.3%;
      }
      > .img-box {
        max-width: 204px;
        margin: 0 auto 20px;
      }
      > .card-body {
        > .card-title {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 25px;
        }
        > .card-text {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
}

/*スライダー部分*/
.swiper-box {
  position: relative;
  .swiper-container {
    max-width: 1100px;
    padding-bottom: 30px;
  }
  .swiper-pagination-bullet-active {
    background-color: $primary;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 7px;
    @include mq-up(md) {
      bottom: 0px;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    margin-top: -54px;
    @include mq-down(md) {
      display: none;
    }
  }
  .swiper-button-prev {
    background-image: url("@/assets/images/icons/arrow-left-swiper.svg");
    background-size: 20px 33px;
    left: 20px;
  }
  .swiper-button-next {
    background-image: url("@/assets/images/icons/arrow-right-swiper.svg");
    background-size: 20px 33px;
    right: 20px;
  }
  .-over {
    &:hover {
      opacity: 0.75;
    }
  }
}

.btn-bg {
  &.flex {
    @include mq-down(md) {
      @include flex(flex, center, flex-start, row, wrap);
    }
  }
  .btn-main {
    width: 410px !important;
    border-radius: 48px !important;
    .txt01 {
      font-size: 14px;
      color: $primary;
      font-weight: bold;
    }
  }
  .right-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    @include mq-down(md) {
      border-top: 1px solid $secondary;
      border-bottom: 1px solid $secondary;
      display: flex;
    }
    @include mq-up(md) {
      justify-content: flex-end;
      max-width: 360px;
    }
    .left,
    .right {
      @include mq-down(md) {
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 15px;
        width: 50%;
        display: flex;
        align-items: center;
      }
      > a {
        &:hover {
          color: $primary;
        }
      }
    }
    .left {
      @include mq-down(md) {
        border-right: 1px solid $secondary;
      }
    }
    .btn-01,
    .btn-02 {
      display: inline-block;
      @include mq-down(md) {
        display: flex;
        align-items: center;
      }
      .icon-box {
        @include mq-up(md) {
          text-align: center;
        }
      }
      .txt02 {
        background-image: url("@/assets/images/icons/arrow-right-gray.svg");
        background-position: right center;
        background-repeat: no-repeat;
        background-size: 8px 14px;
        display: block;
        padding-right: 15px;
        @include mq-up(md) {
          padding-right: 18px;
        }
        @include mq-down(md) {
          font-size: 12px;
        }
      }
      img {
        width: 30px;
        display: block;
        @include mq-up(md) {
          margin: 0 auto 5px;
        }
        @include mq-down(md) {
          float: left;
          margin-right: 12px;
        }
      }
    }
  }
}

.tab-bordered {
  .tab-body {
    > .list-group {
      > .list-item {
        > .atag {
          > .date {
            display: block;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
